<template>
    <div class="tinymce-box">
        <editor v-model="myValue"
          :init="init"
          :disabled="disabled"
          @onClick="onClick">
        </editor>
    </div>
</template>

<script>
/* eslint-disable */
import tinymce from 'tinymce/tinymce' //tinymce默认hidden，不引入不显示
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/icons/default'
// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import 'tinymce/plugins/image'// 插入上传图片插件
import 'tinymce/plugins/media'// 插入视频插件
import 'tinymce/plugins/table'// 插入表格插件
import 'tinymce/plugins/lists'// 列表插件
import 'tinymce/plugins/wordcount'// 字数统计插件
import 'tinymce/plugins/fullscreen'// 
import './lineheight/plugin'// 
import {uploadTin,uploadFile } from "./upload";
export default {
    components:{
        Editor
    },
    name:'tinymce',
    props: {
        basePath: String,
        rootPath: String,
        value: {
          type: String,
          default: ''
        },
        accept: { // 文件类型
          default: 'image/jpeg, image/png',
          type: String
        },
        maxSize: { // 大小
          default: 2097152,
          type: Number
        },
        disabled: {
          type: Boolean,
          default: false
        },
        plugins: {
          type: [String, Array],
          default: 'lists image media table wordcount fullscreen lineheight'
        },
        toolbar: {
          type: [String, Array],
          default: () => {
            return [
              'fullscreen undo redo | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent',
              'fontselect | fontsizeselect | lineheight | lists image media table | removeformat | customButton'
            ]
          }
        }
    },
    data(){
        return{
            editid: null,
            token:this.$store.state.token,
            resVideo:null,//七牛云返回的视频url
            init: {
                language_url: this.basePath + 'static/tinymce/langs/zh_CN.js',
                language: 'zh_CN',
                skin_url: this.basePath + 'static/tinymce/skins/ui/oxide',
                // skin_url: 'tinymce/skins/ui/oxide-dark',//暗色系
                height: 400,
                zIndex: 88,
                plugins: this.plugins,
                fontsize_formats: "12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px 38px 40px",
                lineheight_val: "1 1.1 1.2 1.4 1.5 1.6 1.7 1.8 2 2.2 2.5 3 4",
                font_formats: "微软雅黑=Microsoft Yahei;黑体=SimHei;宋体=SimSun;楷体=KaiTi;隶书=STLiti;Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                toolbar: this.toolbar,
                branding: false,
                menubar: false,

                relative_urls: false,
                remove_script_host: false,

                // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
                // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
                // images_upload_handler: (blobInfo, success, failure) => {
                //   const img = 'data:image/jpeg;base64,' + blobInfo.base64()
                //   success(img)
                // }
                init_instance_callback : function(editor) {
                  this.editid = editor.id;
                  editor.execCommand("fontSize", false, "20px");
                  editor.execCommand("fontName", false, "宋体");
                  editor.formatter.apply('lineheight', { value: '1.4' });


                    // console.log("ID为: " + editor.id + " 的编辑器已初始化完成.");
                },
                setup: function(editor) {
                  // 固定格式button
                  editor.ui.registry.addButton('customButton', {
                    text: '全文：20号宋体',
                    onAction: function() {
                      editor.selection.select(editor.getBody(), true);

                      editor.execCommand("fontSize", false, "20px");
                      editor.execCommand("fontName", false, "宋体");
                      editor.formatter.apply('lineheight', { value: '1.4' });
                      // console.log('ok...')
                      // console.log(editor)
                      // console.log(tinymce)
                    }
                  });
                },
                // xhj
              images_upload_handler: (blobInfo, success, failure) => {
                let that=this;
                if (blobInfo.blob().size > this.maxSize) {
                  // failure('文件体积过大')
                }
                if (this.accept.indexOf(blobInfo.blob().type) >= 0) {
                  uploadPic();
                } else {
                  // failure('图片格式错误')
                }
                function uploadPic() {
                  let formData = new FormData()
                  // 服务端接收文件的参数名，文件数据，文件名
                  formData.append('upfile', blobInfo.blob(), blobInfo.filename())
                  uploadTin(blobInfo, '/sys/utils/uploadPic', that.token).then(res => {
                    // 这里返回的是你图片的地址
                    // console.log(res.data.obj.pic)
                    // alert(res.data.url)
                    let src = that.rootPath + res.data.obj.pic;
                    success(src);
                    that.$emit('imgInsert', res.data.obj.pic);
                  })
                  .catch(() => {
                    failure('上传失败')
                  })
                }
              },
            // 上传所有的文件类型
            // file_picker_callback: (callback, value, meta)=> {
            //   // alert(meta.filetype)
            //       let filetype=meta.filetype;
            //   // if(meta.filetype == 'media'){  
            //       let input = document.createElement('input');//创建一个隐藏的input
            //       input.setAttribute('type', 'file');
            //       let that = this;
            //       input.onchange = function(){
            //         let file = this.files[0];//选取第一个文件
            //         that.$startLoading();
            //         uploadFile(file,'/sys/utils/uploadPic',that.token,filetype).then(res => {
            //          that.$endLoading()
            //          if(res.data.status == 200){
            //              callback(that.rootPath + res.data.obj.pic)  // 上传视频拿到url将url显示在弹框输入框中
            //           }else{
            //               that.$message.error(res.data.msg);
            //           }
            //         })
            //         .catch((err) => {
            //             console.log(err)
            //             // that.$endLoading()
            //          that.$message.error(err);
            //           // callback(that.resVideo, { title: file.name })
            //         })
            //       }
            //       //触发点击
            //       input.click();
            //   // }  
            // } 

          },
          myValue: this.value
        }
    },
    mounted () {
        tinymce.init({});
    },
    methods: {

    // 上传视频拿到url
  	uploadFileUrl(token,file,type){
  	    console.log(file)
    },
        // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
        // 需要什么事件可以自己增加
        onClick (e) {
          this.$emit('onClick', e, tinymce)
        },
        // 可以添加一些自己的自定义事件，如清空内容
        clear () {
          this.myValue = ''
        }
    },
    watch: {
        value (newValue) {
          //tinymce.remove();
          this.myValue = newValue;
        },
        myValue (newValue) {
          this.$emit('input', newValue)
        }
    }
}
    
</script>
<style lang="less">
.tinymce-box .tox .tox-editor-header {
  z-index: 100;
}
</style>